import BlackPointPage from './BlackPointPage';

export default BlackPointPage;
